/* istanbul ignore next */

export const loadLanguageFile = async (lang: string) =>
  require(`../../translations/${lang}.js`);
